<template lang="pug">
main.error-page
  template(v-if='is404')
    .error-page__image-wrapper
      img.error-page__image(src='~assets/images/error-404-recepies.svg', alt='На этой странице ничего нет')
    h1.error-page__title Ошибка 404
    h2.error-page__subtitle Что происходит?
    p.error-page__description По этой ссылке у нас ничего нет. Зато есть много других полезных рецептов:
    ul.error-page__links(v-if='!!recipes &&  fetchStatus !== "error" && fetchStatus !== "pending" ')
      li(v-for='item of recipes', :key='item.id')
        a.error-page__link(:href='item.url') {{ item.title }}

  template(v-else)
    ErrorInfo(:error="error")
    .error-page__image-wrapper
      img.error-page__image.error-page__image--503(src='~assets/images/error-503.svg')
    h1.error-page__title Ошибка 503
    h2.error-page__subtitle Что происходит?
    p.error-page__description.error-page__description--503 Что-то не так с нашим сервером. Обновите страницу или немного подождите — скоро всё заработает.
</template>

<script lang="ts">
  import { computed } from 'vue';
  import ErrorInfo from '@devhacker/shared/components/ErrorInfo.vue';

  export default defineNuxtComponent({
    name: 'RecipeErrorContainer',

    components: { ErrorInfo },

    props: {
      error: {
        type: Object,
        required: true,
      },
    },

    async setup(props) {
      const is404 = computed(
        () => (props.error?.statusCode === 404 || props.error?.message?.includes('404')) ?? false,
      );

      let fetchStatus;
      let recipes;

      if (is404.value) {
        const { data, status, error } = await useAsyncData(() =>
          useNuxtApp().$recipesApi.fetchHomeRecipes(1, 3),
        );

        if (error.value) {
          console.error('Error in RecipeErrorContainer.vue:', error.value);
        }

        recipes = data.value?.items;
        fetchStatus = status;
      }

      return {
        is404,
        recipes,
        fetchStatus,
      };
    },
  });
</script>

<style lang="scss" scoped>
  .error-page {
    background: white;
    height: 100%;
    border: 1px solid $borderColor;

    &__image-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 232px;
      margin-top: 32px;
      margin-bottom: 16px;
    }
    &__image {
      width: 288px;
      height: 232px;

      &--503 {
        width: 264px;
        height: 142px;
      }
    }
    &__title {
      @include fontH1;
      text-align: center;
      margin-bottom: 32px;

      @include tablet {
        margin-bottom: 40px;
      }
    }
    &__subtitle {
      @include fontH2;
      margin-bottom: 12px;
    }
    &__description {
      @include fontNormalText;
      margin-bottom: 8px;

      &--503 {
        margin-bottom: 32px;
      }

      @include tablet {
        @include fontMediumText;

        &--503 {
          margin-bottom: 40px;
        }
      }
    }
    &__description,
    &__subtitle {
      @include margin-x(16px);
      @include tablet {
        @include margin-x(24px);
      }
    }
    &__links {
      margin-bottom: 32px;
      @include margin-x(32px);
      @include fontNormalText;

      li + li {
        margin-top: 8px;
      }

      @include mobile {
        margin-bottom: 40px;
      }

      @include tablet {
        @include margin-x(40px);
      }
    }

    &__link {
      @include linkStyle;
    }
  }
</style>
